
import React, { Component, useEffect, useState, useMemo } from "react";
import styles from './login.module.css'
import { connect } from 'react-redux';
import { Checkbox } from 'antd-mobile';
import PhoneIphone from '@material-ui/icons/PhoneIphone';
import { message, Modal } from "antd";
import { loginAction, sendSmsVerifyCode } from "../actions/UserAction";
import HttpUtils from "../../../utils/HttpUtils";
import { addFavoriteApi } from "../../WMS/WebService";

const Index = ({ dispatch, navigate, router }) => {
  const [countdown, setCountdown] = useState(0);
  const [buttonText, setButtonText] = useState("验证码");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [showError, setShowError] = useState(false)

  const [mobile, setMobile] = useState("");
  const mobileError = useMemo(() => {
    if (!showError) return false
    const phoneRegex = /^1[3-9]\d{9}$/;
    return !phoneRegex.test(mobile);
  }, [mobile, showError]);

  const [mobileVerifyCode, setMobileVerifyCode] = useState("");
  // console.log(mobileVerifyCode);
  const mobileVerifyCodeError = useMemo(() => {
    if (!showError) return false
    return !mobileVerifyCode || mobileVerifyCode.length != 6;
  }, [mobileVerifyCode, showError]);



  const [agree, setAgree] = useState(false);

  useEffect(() => {
    let interval = null;

    if (countdown > 0) {
      interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    } else if (countdown === 0 && buttonDisabled) {
      setButtonDisabled(false);
      setButtonText("验证码");
    }

    return () => clearInterval(interval);
  }, [countdown, buttonDisabled]);

  const codeHandleClick = () => {
    if (buttonDisabled) return;
    if (mobileError) return;
    setButtonDisabled(true);
    setButtonText("请等待...");
    setCountdown(60);
    getMobileVerifyCode();
  };

  const getMobileVerifyCode = () => {
    dispatch(sendSmsVerifyCode(mobile));
  };

  const loginHandle = () => {

    if (!mobile || !mobileVerifyCode) {
      setShowError(true)
      return
    }

    if (mobileError || mobileVerifyCodeError) {
      return;
    }
    if (!agree) {
      return message.info("请选择我已阅读并同意《i选址用户协议》");
    }

    dispatch(
      loginAction({
        mobile,
        mobileVerifyCode,
      }, () => {
        let redirect = HttpUtils.getQueryString('redirect')

        if (redirect.includes('login')) {
          redirect = '/'
        }

        let collectZoneId = sessionStorage.getItem('collectZoneId')
        if (collectZoneId) {

          HttpUtils.post(addFavoriteApi, { zoneId: collectZoneId }, () => {
            sessionStorage.removeItem('collectZoneId')
            router.navigate({
              pathname: redirect ? decodeURIComponent(redirect) : '/',
            })
          }, () => { })

        } else {
          router.navigate({
            pathname: redirect ? decodeURIComponent(redirect) : '/',
          })
        }



      })
    );
  };

  const _onCancel = () => {
    // dispatch(toggleLoginModalShow(false))
  };

  let [userAgreementShow, setUserAgreementShow] = useState(false)

  return (
    <div className={styles.login}>
      <div className={styles.loginHead}>

      </div>
      <div className={styles.phoneWrap}>
        <h6>
          <PhoneIphone className={styles.phoneIcon} style={{ marginRight: "10px", height: '1.5em', width: '1.5em' }} />
          手机验证码登录
        </h6>
        <div className={styles.formItem}>
          <div className={styles.formField}>
            <input placeholder="请输入手机号" onChange={(e) => {
              setShowError(false)
              setMobile(e.target.value);
            }} />
          </div>
          {mobileError && (
            <div className={styles.err}>请输入正确的手机号</div>
          )}
        </div>
        <div className={styles.formItem}>
          <div className={styles.formField}>
            <input value={mobileVerifyCode} placeholder="短信验证码" onChange={(e) => {
              setShowError(false)
              setMobileVerifyCode(e.target.value.substring(0, 6));
            }} />
            <div
              className={
                buttonDisabled ? styles.disabledCode : styles.code
              }
              onClick={codeHandleClick}
              disabled={buttonDisabled}
            >
              {countdown > 0 ? `${countdown}秒` : buttonText}
            </div>
          </div>
          {mobileVerifyCodeError && (
            <div className={styles.err}>请输入正确的验证码</div>
          )}
        </div>
        <div className={styles.loginBtn} onClick={loginHandle}>立即登录</div>
        <div className={styles.protocol}>
          <Checkbox.CheckboxItem onChange={(e) => setAgree(e.target.checked)} className={styles.checkboxItem}>我已阅读并同意<a href="javaScript:;" onClick={() => { setUserAgreementShow(true) }} >《i选址用户协议》</a></Checkbox.CheckboxItem>
        </div>
        <Modal title="" centered={true} open={userAgreementShow} footer={null} onCancel={() => setUserAgreementShow(false)}>
          <div style={{ height: '70vh', overflow: 'auto' }}>
            <h3>瑞莱博用户使用协议</h3>
            <h4>一、总则</h4>
            <p>您在使用i选址(上海瑞莱博信息技术有限公司，以下简称“瑞莱博”)提供的各项服务之前，请您务必审慎阅读、充分理解本协议各条款内容。您一旦使用本网站，即视为您已成为i选址的网站用户，且已了解并完全同意本服务协议各项内容，包括i选址对服务协议后续将作出的任何修改。</p>
            <h4>二、用户信息使用及保护规则</h4>
            <p>因您使用网站而获取的信息有：</p>
            <p>2.1 日志信息：当您使用网站时，服务器会自动记录一些信息，例如您所在的IP地址、所访问网站的链接、访问日期和时间等。</p>
            <p>2.2 Cookie：cookie的使用会保留您的操作习惯，以便为您增强网站浏览体验。您也可以通过修改浏览器设置的方式关闭cookie；若关闭cookie，您可能无法在网站部分功能获得良好的体验。 本网站采集的数据信息都采用匿名方式，网站也会对信息采取加密处理，保证信息的安全性。</p>

            <h4>三、使用规则</h4>
            <p>3.1 用户在使用网站服务时，必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列行为：</p>
            <p>(1) 不得为任何非法目的而使用网络服务系统；</p>
            <p>(2) 不利用网站从事以下活动:</p>
            <p>1) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；</p>
            <p>2) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；</p>
            <p>3) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、 修改或者增加的；</p>
            <p>4) 故意制作、传播计算机病毒等破坏性程序的；</p>
            <p>5) 其他危害计算机信息网络安全的行为。</p>
            <p>3.2 当用户违反本协议或相关服务条款的规定，导致或产生的任何损失，i选址（瑞莱博）有权追究其法律责任。</p>
            <p>3.3 用户不得对本网站信息，进行复制、拷贝、出售、转售或用于任何其它商业目的。</p>
            <h4>四、服务内容</h4>
            <p>4.1 i选址（瑞莱博）服务的具体内容来源于一线仓储市场，网站以实际获取的情况提供信息。</p>
            <p>4.2 鉴于网络服务的特殊性，用户同意i选址有权不经事先通知，随时变更、中断或终止部 分或全部的网络服务。i选址（瑞莱博）不担保网络服务不会中断，对网络服务提供的数据信息的及时性、安全性、准确性也都不作担保。</p>

            <h4>五、其他</h4>
            <p>5.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
            <p>5.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向i选址（瑞莱博）所在地上海市闵行区人民法院提起诉讼。</p>
            <p>5.3 本网站有权在必要时修改协议条款，协议条款一旦发生变动，将会在页面上提示修改内容。如果不同意所改动的内容，用户可以主动取消获得的本网站信息服务。如果用户继续享用本网站信息服务，则视为接受服务条款的变动。本网站保留随时修改或中断服务而不需通知用户的权利。本网站行使修改或中断服务的权利，不需对用户或第三方负责。</p>
          </div>

        </Modal>
      </div>
    </div>
  );
};


function mapStateToProps(store) {
  return {};
}

export default connect(mapStateToProps)(Index);
